
<template>
    <div ref="listWrap">
        <wrapper-list
                @edit="paasEidtPage"
                @delete="paasDeleteTableData"
                @detail="paasDetailPage"
                @calculate="paasCalculate"
                ref="wrapperList" >
            <Form class="list-query-wrap" slot="query" :model="queryParam" :label-width="defaultLabelWidth" ref="queryForm">
                <row class="list-query-row">
                    <FormItem label="订单号" class="list-query-item">
                        <Input  v-model="queryParam.query_LIKE_orderCode" placeholder=""
                                @on-change="queryTableDatas('param')" clearable />
                    </FormItem>
                    <FormItem label="物流编号" class="list-query-item">
                        <Input  v-model="queryParam.query_LIKE_expressCode" placeholder=""
                                @on-change="queryTableDatas('param')" clearable />
                    </FormItem>
                </row>
            </Form>
            <Table slot="table" stripe border :height="tableHeight"
                   :data="tableData"
                   :columns="tableColumns"
                   @on-selection-change="selectTableDataChange"
                   @on-sort-change="sortTableData"
                   :no-data-text="noDataText">
            </Table>
            <Page slot="page"  :total="totalRecords"
                  show-total show-sizer
                  @on-change="changePage"
                  @on-page-size-change="changePageSize">
            </Page>
        </wrapper-list>
    </div>
</template>
<script>
    import wrapperList from "@components/paas/wrapper-list";
    import metaList from "@assets/js/list/meta-list.js";
    import CellBar from '@components/paas/cell-bar' //列表内操作
    import EnumShow from "@components/paas/enum-show";  //如果有枚举，需要引入
    export default {
        name: "list",
        mixins: [ metaList ],
        components: { wrapperList,CellBar, EnumShow},
        data() {
            return {
                serviceUrl:"/eb/order/send",  //每个页面访问后台服务器的路径
                currentIdFiledName: 'id',
                queryParam:{
                    query_LIKE_orderCode:"",
                    query_LIKE_expressCode:"",
                    query_EQ_status:"1"
                },
                order:{},
                paasData:[],
                index:0,
                defaultLabelWidth:200,
                addExpressModal:false,
                expressDetail:false,
                tableColumns:[
                    {
                        type: 'expand',
                        width: 50,
                        render: (h, params) => {
                            return h(OrderExpand, {
                                props: {
                                    rowData: params.row
                                }
                            })
                        }
                    },
                    {
                        title: '订单号',
                        key: 'orderCode',
                        width:200,
                    },
                    {
                        title: '物流名称',
                        key: 'expressName',
                        "width": 160,
                    },

                    {
                        title: '物流编号',
                        key: 'expressCode',
                        width:130,
                    },
                    {
                        title: '发货人',
                        key: 'operateName',
                        width:200
                    },
                    {
                        title: '发货时间',
                        key: 'completeTime',
                    },
                    {
                        title: '操作',
                        "width": 200,
                    render: (h, params) => {
                    return h(CellBar,
                      {
                      props:{
                        show:'text'  //操作也显示标准按钮的样式（text、icon、textIcon）
                      },
                      //自定义事件监听器“on”,不支持如v-on:keyup.enter的修饰符，需要手动匹配keyCode
                        on: {
                          // 子组件$emit传递函数,必须是箭头函数写法
                          'edit': ()=> {
                            this.$nextTick(()=>{
                              this.paasEditOper(params.row[this.currentIdFiledName]);
                            })
                          },
                        }
                    }
                )}
            }
                ],
            }
        },
        mounted(){
        },
        methods:{
        }
    }
</script>
